import { render } from "./DokterScan.vue?vue&type=template&id=0f647337"
import script from "./DokterScan.vue?vue&type=script&lang=js"
export * from "./DokterScan.vue?vue&type=script&lang=js"

import "./DokterScan.vue?vue&type=style&index=0&id=0f647337&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__